var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M0 1.5h2v13h-2v-13z"}}),_c('path',{attrs:{"d":"M0 12.5h16v2h-16v-2z"}}),_c('path',{attrs:{"d":"M3.96 12l-1.478-0.982 5.268-7.885 2.838 4 2.81-4.58 1.515 0.928-4.215 6.893-2.9-4.1z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }